import { getEnv } from '@dev.boon/wolfe/config/endpoints';

const getEndpointPrefix = (addHypen = true): string => {
    const hypen = addHypen ? '-' : '';
    let endpointPrefix = `staging${hypen}`;

    if (typeof window !== 'undefined') {
        endpointPrefix =
            !window.location.host.includes('staging') &&
            !window.location.host.includes('testing') &&
            !window.location.host.includes('localhost')
                ? ''
                : window.location.host.includes('testing')
                ? `testing${hypen}`
                : `staging${hypen}`;
    }

    return endpointPrefix;
};

export const ADLER_API = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_ADLER_API ?? 'http://localhost:8081';
    }
    return `https://${getEndpointPrefix()}adler.booninterior.com`;
})();

export const ASHWELL_API = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_ASHWELL_API ?? 'http://localhost:8085';
    }
    return `https://${getEndpointPrefix()}ashwell.booninterior.com`;
})();

export const DIXON_API = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_DIXON_API ?? 'http://localhost:8086';
    }
    return `https://${getEndpointPrefix()}dixon.booninterior.com`;
})();

export const DIXON_WEBSOCKET_URL = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_DIXON_WEBSOCKET_URL ?? 'ws://localhost:8087';
    }
    return `wss://${getEndpointPrefix()}dixon-ws.booninterior.com`;
})();

export const FULK_API = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_FULK_API ?? 'http://localhost:8082';
    }
    return `https://${getEndpointPrefix()}fulk.booninterior.com`;
})();

export const WOLFE_URL = ((): string => {
    const subDomain = getEndpointPrefix(false) === '' ? 'www' : getEndpointPrefix(false);
    return `https://${subDomain}.booninterior.com`;
})();

export const STATIC_POOLEY_URL = ((): string => {
    return `https://${getEndpointPrefix()}pooley-static.booninterior.com`;
})();

export const POOLEY_URL = ((): string => {
    if (getEnv() === 'localhost') {
        return process.env.NEXT_PUBLIC_POOLEY_URL ?? 'http://localhost:8088';
    }
    return `https://${getEndpointPrefix()}pooley.booninterior.com`;
})();
